import { useEffect } from 'react';

const useDraggable = (ref, callback) => {
    const handleClick = (e) => {
        if (ref.current && ref.current === e.currentTarget) {
            callback(e.currentTarget);
        }
    };

    const handleDrag = (e) => {
        if (ref.current && ref.current === e.currentTarget) {
            callback(e.currentTarget);
        }
    };

    const handleTouch = (e) => {
        if (ref.current && ref.current === e.currentTarget) {
            callback(e.currentTarget);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClick);
        // document.addEventListener('drag', handleDrag);
        // document.addEventListener('mousedown', handleDrag);
        document.addEventListener('touchstart', handleTouch);
        // document.addEventListener('touchmove', handleTouch);
        return () => {
            document.removeEventListener('click', handleClick);
            // document.removeEventListener('drag', handleDrag);
            // document.removeEventListener('mousedown', handleDrag);
            document.removeEventListener('touchstart', handleTouch);
            // document.removeEventListener('touchmove', handleTouch);
        };
    }, []);
};

export default useDraggable;
